import ProductSystem from '@/models/ProductSystem';

export class ProductSystemRepository {
    public static getAll() {
        return ProductSystem.query().withAllRecursive().get();
    }

    public static getAllShallow() {
        const seenNames = new Set<string>();
        return ProductSystem.all().filter((system) => {
            if (seenNames.has(system.name)) {
                return false;
            }
            seenNames.add(system.name);
            return true;
        });
    }

    public static getById(productSystemId: string) {
        return ProductSystem.query().withAllRecursive().whereId(productSystemId).first();
    }
}
